import entityReducer from "./applicationEntityReducer";

const reducers = { entities: entityReducer };

export default reducers;
